import { Component, Inject } from '@angular/core';
import { IncomeProofBottomsheetComponent } from '../income-proof-bottomsheet/income-proof-bottomsheet.component';
import { Router } from '@angular/router';
import { clevertapPush, ModificationCommonService } from '../../services/modification-common.service';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-confirmation-bottomsheet',
  imports: [CommonModule],
  templateUrl: './confirmation-bottomsheet.component.html',
  styleUrl: './confirmation-bottomsheet.component.less'
})
export class ConfirmationBottomsheetComponent {
  session_id: string = '';
  clientStatus: number = 0;
  btnLoader = false;
  txtContant: string = '';
  status_3_Msg: boolean = false;

  constructor(
      private router: Router,
      private modificationCommonService: ModificationCommonService,
      private _bottomSheetRef: MatBottomSheetRef<ConfirmationBottomsheetComponent>,
      @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
      private _bottomSheet: MatBottomSheet
  ) {
      this.session_id = data.session_id;
      this.clientStatus = data.status;
      if (this.clientStatus == 3) {
          this.status_3_Msg = true;
      }
      if (this.clientStatus == 3 && this.status_3_Msg) {
          this.txtContant = 'Would you like to upload Statement from a different bank?';
      } else {
          this.txtContant = 'Would you like to upload documents like Salary Slip or Income Tax Return as income proof (Other than Bank Statements)?';
      }
  }

  bottomSheetClose() {
      if (this.clientStatus == 3 && this.status_3_Msg) {
          this.txtContant = 'Would you like to upload documents like Salary Slip or Income Tax Return as income proof (Other than Bank Statements)?';
          this.status_3_Msg = false;
      } else {
          clevertapPush('Segment_Activation_MOD', { action: 'MOD_SEG_FIN_MANUAL_NO' });
          this._bottomSheetRef.dismiss();
          this.router.navigateByUrl('/derivative/fail-page');
      }
  }

  documentUploadBottomSheet(): void {
      this.clientStatus == 3
          ? this.status_3_Msg
              ? this.finboxSDKURL()
              : this.incomeProofBottomsheet()
          : this.incomeProofBottomsheet();
  }

  finboxSDKURL() {
      clevertapPush('Segment_Activation_MOD', { action: 'MOD_SEG_FIN_AGAIN_YES' });
      this.modificationCommonService.getVendorURL();
  }

  incomeProofBottomsheet(){
       clevertapPush('Segment_Activation_MOD', { action: 'MOD_SEG_FIN_MANUAL_YES' });
       this._bottomSheet.open(IncomeProofBottomsheetComponent)
  }
}
